import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scratch',
  templateUrl: './scratch.component.html',
  styleUrls: ['./scratch.component.scss'],
})
export class ScratchComponent implements OnInit {
  modulesText = {
    text: 'Il corso parte con l’introdurre la piattaforma di Scratch, approfondendo il concetto di algoritmo e imparando a inserire le istruzioni disegnando forme e oggetti che diventano sempre più complessi.',
  };

  constructor() {}

  ngOnInit(): void {}
}
